var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CompassArrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6222 22.9932C13.6222 22.9932 13.5722 22.9932 13.5422 22.9932C12.6022 22.9632 11.8222 22.3632 11.5522 21.4632L9.37216 14.2432C9.35216 14.1932 9.31217 14.1532 9.26217 14.1332L2.04216 11.9532C1.14216 11.6732 0.532165 10.8932 0.502165 9.96321C0.472165 9.02321 1.01216 8.20321 1.89216 7.87321L19.5722 1.14321C20.3822 0.833209 21.2522 1.02321 21.8622 1.63321C22.4722 2.24321 22.6622 3.12321 22.3522 3.92321L15.6222 21.6032C15.3022 22.4532 14.5122 22.9932 13.6122 22.9932H13.6222ZM20.3422 2.99321C20.3422 2.99321 20.2922 2.99321 20.2822 3.00321L2.60216 9.73321C2.60216 9.73321 2.49217 9.77321 2.50217 9.88321C2.50217 9.99321 2.58217 10.0132 2.61216 10.0332L9.83216 12.2132C10.5222 12.4232 11.0622 12.9632 11.2722 13.6532L13.4522 20.8732C13.4522 20.8732 13.4822 20.9832 13.6022 20.9832C13.7222 20.9832 13.7422 20.9132 13.7522 20.8832L20.4922 3.21321C20.4922 3.21321 20.5322 3.11321 20.4522 3.04321C20.4122 3.00321 20.3722 2.99321 20.3422 2.99321Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassArrow);
export default __webpack_public_path__ + "static/media/CompassArrow.57a42efd8902bd21b1b75b302924c559.svg";
export { ForwardRef as ReactComponent };